<template>
  <div class="container">
    <div
      class="mb-8 mx-auto max-w-2xl content-start border-2 border-black rounded-xl p-8 bg-white home-vips-item"
    >
      <div class="text-center text-6xl">
        Gelukt!
      </div>
      <div class="text-center text-5xl">
        Binnen 12 uur ontvang jij je ShoutOut in je inbox!
      </div>

      <div class="flex mt-4">
        <Link
          :href="localeRoute('frontend.index')"
          class="button-orange shadow-button-black inline-block mx-auto"
        >
          {{ __('general.see-all-vips') }}
        </Link>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultWithoutFooter from '../../../Layout/DefaultWithoutFooter.vue';

export default {
  layout: DefaultWithoutFooter,
};
</script>
